import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function GuidesSection() {
  const { t } = useTranslation();

  return (
    <section id="guides" className="w-full px-4 md:px-6 lg:px-8 py-14 md:py-20 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="flex items-end justify-between mb-8 md:mb-10">
          <div>
            <span className="text-sm font-medium text-primary-600 uppercase tracking-widest mb-2 block">
              Resources
            </span>
            <h2 className="font-heading text-3xl md:text-4xl font-semibold text-foreground-950">
              {t('articles_title')}
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5 md:gap-6">
          {articles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group block bg-white border border-background-200/70 rounded-lg overflow-hidden hover:border-primary-300/60 transition-all hover:shadow-md"
            >
              <div className="aspect-[3/2] overflow-hidden bg-background-100">
                <img
                  src={article.image}
                  alt={t(article.titleKey)}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-4 md:p-5">
                <div className="flex items-center gap-2 mb-2">
                  <span className="px-2 py-0.5 bg-primary-50 text-primary-700 text-xs font-medium rounded">
                    {article.category}
                  </span>
                  <span className="text-xs text-foreground-400">{article.readTime}</span>
                </div>
                <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors leading-snug">
                  {t(article.titleKey)}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2">
                  {t(article.descKey)}
                </p>
                <span className="inline-flex items-center gap-1 text-sm text-primary-600 font-medium mt-3 group-hover:gap-2 transition-all">
                  {t('articles_read_more')}
                  <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center" />
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}